import React from "react";
import ModalHeader from 'react-bootstrap/ModalHeader'

function STCModalHeader(props){

    return(
        <ModalHeader
            style={props.style}
            className={props.className}
            onClick={props.onClick}

            bsPrefix={props.bsPrefix}
            closeLabel={props.closeLabel}
            closeVariant={props.closeVariant}
            closeButton={props.closeButton}
            onHide={props.onHide}
               
        >
            {props.children}
        </ModalHeader>
    )
}
export default STCModalHeader;